var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.25,
    height: 14,
    viewBox: "0 0 12.25 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M11.867-10.445a1.266,1.266,0,0,1,.383.93v7.328a1.266,1.266,0,0,1-.383.93,1.266,1.266,0,0,1-.93.383H8.75V.438a1.266,1.266,0,0,1-.383.93,1.266,1.266,0,0,1-.93.383H1.313a1.266,1.266,0,0,1-.93-.383A1.266,1.266,0,0,1,0,.438v-8.75a1.266,1.266,0,0,1,.383-.93,1.266,1.266,0,0,1,.93-.383H3.5v-1.312a1.266,1.266,0,0,1,.383-.93,1.266,1.266,0,0,1,.93-.383h4.7a1.266,1.266,0,0,1,.93.383Zm-2.242-.93v1.75h1.75a.73.73,0,0,0-.137-.191L9.816-11.238A.73.73,0,0,0,9.625-11.375ZM7.875.438V-.875H4.813a1.266,1.266,0,0,1-.93-.383,1.266,1.266,0,0,1-.383-.93V-8.75H1.313A.426.426,0,0,0,1-8.627a.426.426,0,0,0-.123.314V.438a.421.421,0,0,0,.438.438H7.438A.421.421,0,0,0,7.875.438Zm3.5-2.625V-8.75H9.406a.633.633,0,0,1-.465-.191.633.633,0,0,1-.191-.465v-1.969H4.813a.426.426,0,0,0-.314.123.426.426,0,0,0-.123.314v8.75a.426.426,0,0,0,.123.314.426.426,0,0,0,.314.123h6.125a.426.426,0,0,0,.314-.123A.426.426,0,0,0,11.375-2.187Z",
    transform: "translate(0 12.25)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6071ca248ae7dbac63148888cab4ae4a.svg";
export { ForwardRef as ReactComponent };